/**
 * @generated SignedSource<<47f58c47b85ca7776e5b2ed6ae2ab2b8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type routeRankingEnabledQuery$variables = {
  slug: string;
};
export type routeRankingEnabledQuery$data = {
  readonly club: {
    readonly configuration: string | null | undefined;
  };
};
export type routeRankingEnabledQuery = {
  response: routeRankingEnabledQuery$data;
  variables: routeRankingEnabledQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
],
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "LEADERBOARD"
    }
  ],
  "kind": "ScalarField",
  "name": "configuration",
  "storageKey": "configuration(key:\"LEADERBOARD\")"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "routeRankingEnabledQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Club",
        "kind": "LinkedField",
        "name": "club",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "routeRankingEnabledQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Club",
        "kind": "LinkedField",
        "name": "club",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1ed6574a3a20d5eefcaf64c1508e099f",
    "id": null,
    "metadata": {},
    "name": "routeRankingEnabledQuery",
    "operationKind": "query",
    "text": "query routeRankingEnabledQuery(\n  $slug: String!\n) {\n  club(slug: $slug) {\n    configuration(key: \"LEADERBOARD\")\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "351885faa7dc7dfa0962af859efd7bd4";

export default node;
